module.exports = __webpack_public_path__ + "static/media/Check-circle.21d92ff3.svg";